"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const react_1 = __importDefault(require("react"));
const icons_1 = __importStar(require("../../icons"));
const switch_base_1 = __importDefault(require("../switch-base/switch-base"));
function RadioIcon({ checked, indeterminate, ...props }) {
    return react_1.default.createElement(checked ? icons_1.DotIcon : icons_1.default, props);
}
exports.Radio = react_1.default.forwardRef(function Radio({ value, ...props }, ref) {
    return react_1.default.createElement(switch_base_1.default, { ref: ref, "aria-checked": !!value, checked: !!value, icon: RadioIcon, round: true, type: "radio", ...props });
});
exports.default = exports.Radio;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmFkaW8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL3JhZGlvL3JhZGlvLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGtEQUEwQjtBQUUxQixxREFBNEM7QUFDNUMsNkVBQThGO0FBTzlGLFNBQVMsU0FBUyxDQUFDLEVBQUUsT0FBTyxFQUFFLGFBQWEsRUFBRSxHQUFHLEtBQUssRUFBdUI7SUFDMUUsT0FBTyxlQUFLLENBQUMsYUFBYSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsZUFBTyxDQUFDLENBQUMsQ0FBQyxlQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7QUFDOUQsQ0FBQztBQUVZLFFBQUEsS0FBSyxHQUFHLGVBQUssQ0FBQyxVQUFVLENBQStCLFNBQVMsS0FBSyxDQUFDLEVBQUUsS0FBSyxFQUFFLEdBQUcsS0FBSyxFQUFFLEVBQUUsR0FBRztJQUN6RyxPQUFPLDhCQUFDLHFCQUFVLElBQUMsR0FBRyxFQUFFLEdBQUcsa0JBQWdCLENBQUMsQ0FBQyxLQUFLLEVBQUUsT0FBTyxFQUFFLENBQUMsQ0FBQyxLQUFLLEVBQUUsSUFBSSxFQUFFLFNBQVMsRUFBRSxLQUFLLFFBQUMsSUFBSSxFQUFDLE9BQU8sS0FBSyxLQUFLLEdBQUksQ0FBQztBQUMxSCxDQUFDLENBQUMsQ0FBQztBQUVILGtCQUFlLGFBQUssQ0FBQyJ9